import React from 'react'
import axios from 'axios'
import {PUBLIC_API_KEY} from 'helper/constants'
import {fireErrorToast} from 'helper/functions'
import {Trans} from '@lingui/macro'

// `withCredentials` indicates whether or not cross-site Access-Control requests
// should be made using credentials , default = false
axios.defaults.withCredentials = true

if (PUBLIC_API_KEY) {
  axios.defaults.headers.common['X-PUBLIC-API-KEY'] = PUBLIC_API_KEY
}

axios.interceptors.request.use((config) => {
  const configCopy = config
  const token = localStorage.getItem('sessionId')

  if (token) {
    configCopy.headers['session-id'] = token
  }

  return configCopy
})

axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    return Promise.reject(error)
  }
)

const timeout = 10000

const setTimeoutErrorMessage = (err) => {
  if (err.message.startsWith('timeout of')) {
    err.message = 'Network Error'
  }
  throw err
}

const post = (
  url,
  data = {},
  config = {
    headers: {
      'Content-Type': 'application/json',
    },
    timeout,
  }
) => {
  return axios.post(url, data, config).catch(setTimeoutErrorMessage)
}

const get = (
  url,
  params = {},
  config = {
    headers: {
      'Content-Type': 'application/json',
    },
  }
) => {
  const configCopy = config
  configCopy.params = params
  return axios.get(url, configCopy)
}

const put = (url, data = {}, config = {timeout}) => {
  return axios.put(url, data, config).catch(setTimeoutErrorMessage)
}

const patch = (url, data = {}, config = {timeout}) => {
  return axios.patch(url, data, config).catch(setTimeoutErrorMessage)
}

const del = (url, config = {timeout}) => {
  return axios.delete(url, config).catch(setTimeoutErrorMessage)
}

const httpClient = {
  post,
  get,
  put,
  del,
  patch,
}

export default httpClient
